/**
 * Generated by scripts/art/pixel-pieces.py: do not edit by hand. The pieces as 28 × 28 pixel
 * sprites, each with its palette, run-length packed (night/pixelPalette.ts): orbs and crystal
 * shards in the void, shells and starfish in the sea, crowned or not, and their shadows.
 */
import type { PixelSprite } from './night/pixelBroker';

export const ORB: PixelSprite = {
  w: 28,
  h: 28,
  palette: [
    '',
    '#0c1a4a',
    '#1f45b0',
    '#3a7ae8',
    '#6cb6ff',
    '#b4dcff',
    '#dff1ff',
    '#ffffff',
    '#8a5a1a',
    '#e0a838',
    '#ffe08a',
    '#fff8dc',
  ],
  runs: '0z0z0z0z0a180j11645341110h11665242110f11627263524231110d114152716353423121110c11625443514232110c1165524235110c11526155433221110c1157443221110c114a3222110c11443822110c1131463423110d1131433424110f113624110h1128110j180z0z0z0z0z0v',
};

export const ORB_CROWNED: PixelSprite = {
  w: 28,
  h: 28,
  palette: [
    '',
    '#0c1a4a',
    '#1f45b0',
    '#3a7ae8',
    '#6cb6ff',
    '#b4dcff',
    '#dff1ff',
    '#ffffff',
    '#8a5a1a',
    '#e0a838',
    '#ffe08a',
    '#fff8dc',
  ],
  runs: '0z0z0r120n1352130i12645341120f1167534215091168534231941207115161726354423196110511537153615343321491061164534432413211039105126654361101930312a15a443222930311a331584433930411a3124552453193110511a1120111415142369422110511a1110211469631231106b5a79134231109b3a43625110d113626110f1228120i1322130n120z0z0z0z0d',
};

export const SHARD: PixelSprite = {
  w: 28,
  h: 28,
  palette: [
    '',
    '#3a0a2c',
    '#6a1650',
    '#b02e70',
    '#ea4f98',
    '#ff9ccb',
    '#ffc9e6',
    '#ffffff',
    '#8a5a1a',
    '#e0a838',
    '#ffe08a',
    '#fff8dc',
  ],
  runs: '0z0y120p115131110n115232110m11517132110l1151615133110j1152615134110i1152615134110h1153615135110f1154615136110e114626110e114626110f114525110g114525110g11443125110h11413324110i113424110j113323110l113222110n113121110p120z0z0z0z0z06',
};

export const SHARD_CROWNED: PixelSprite = {
  w: 28,
  h: 28,
  palette: [
    '',
    '#3a0a2c',
    '#6a1650',
    '#b02e70',
    '#ea4f98',
    '#ff9ccb',
    '#ffc9e6',
    '#ffffff',
    '#8a5a1a',
    '#e0a838',
    '#ffe08a',
    '#fff8dc',
  ],
  runs: '0d120p115131110n115232110m11517132110l1151615133110j1152615134110i11526151341101140c1153615135119412091154615136961108115461513615920711556151371103920512a147271102920511a31146261102920511a213462611930511a21102114624940611a21104114521950811a2051142a19522110911ab9125110ca401113424110j113323110l113222110m113222110n113121110p120z0z0z0k',
};

export const SHELL: PixelSprite = {
  w: 28,
  h: 28,
  palette: [
    '',
    '#121e44',
    '#1d2f63',
    '#2f4886',
    '#3f5b9e',
    '#7090d0',
    '#a2b8ea',
    '#ffffff',
    '#8a5a1a',
    '#e0a838',
    '#ffe08a',
    '#fff8dc',
  ],
  runs: '0z0z0z0z0z04160k126333120h11655233110f116252425234110d116341514251435132110c11624251425142524131110b1161524351415141524133110a113243344136110b143241314133140g113141314132110k11344131110k11314131413141110l160z0z0z0z0z0z0z0i',
};

export const SHELL_CROWNED: PixelSprite = {
  w: 28,
  h: 28,
  palette: [
    '',
    '#121e44',
    '#1d2f63',
    '#2f4886',
    '#3f5b9e',
    '#7090d0',
    '#a2b8ea',
    '#ffffff',
    '#8a5a1a',
    '#e0a838',
    '#ffe08a',
    '#fff8dc',
  ],
  runs: '0c11011101110m11b111b111b1110l11a5110k11a371a3110j1197110i1a0g136434130d13655233130b12625243524134120a126241524252435131120912634251425143533112071262445142514252423212061261534351415141524332120612334334413712071632413141331609163141314132160e12344131120i12314131413141120j180l160z0z0z0z0z0z0p',
};

export const STARFISH: PixelSprite = {
  w: 28,
  h: 28,
  palette: [
    '',
    '#5a1424',
    '#9e2f49',
    '#d85a72',
    '#ff8fa1',
    '#ffb8c4',
    '#ffd9df',
    '#ffffff',
    '#8a5a1a',
    '#e0a838',
    '#ffe08a',
    '#fff8dc',
  ],
  runs: '0z0z0z0z0z0y120p1152110o115161110o1152110i16526151160b11594532110b1151615161554161416131110d12584131120g115731110j11415431110j1141614152316131110i114434110i116141143161110h114211041132110g114111061131110h1108110z0z0z0z09',
};

export const STARFISH_CROWNED: PixelSprite = {
  w: 28,
  h: 28,
  palette: [
    '',
    '#5a1424',
    '#9e2f49',
    '#d85a72',
    '#ff8fa1',
    '#ffb8c4',
    '#ffd9df',
    '#ffffff',
    '#8a5a1a',
    '#e0a838',
    '#ffe08a',
    '#fff8dc',
  ],
  runs: '0c11011101110m11b111b111b1110l11a5110k11a371a3110j1197110k170m140n1252120m1252120m125161120g18521809185261511807125a453312071351615161554161416131130913594132130c135731130f13415431130g1241614152316131120g124434120f1241614212326131120e12431433120e124113021331120d124113041331120d1308130f110a110z0z0m',
};

export const SHADOW: PixelSprite = {
  w: 28,
  h: 28,
  palette: ['', 'rgba(3, 2, 10, 0.45)'],
  runs: '0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0p160i1e0e1e0i160z04',
};

export const SHADOW_WIDE: PixelSprite = {
  w: 28,
  h: 28,
  palette: ['', 'rgba(3, 2, 10, 0.45)'],
  runs: '0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0o180f1i0a1i0f180z03',
};
